/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 *
 * Added for @bfx/provide-webworker multiworker project
 *
 */

import { Inject, EventEmitter, Injectable, Type } from "@angular/core";

import { MessageBus } from "../shared/message_bus";
import { Serializer, PRIMITIVE } from "../shared/serializer";

import { REGISTRY_CHANNEL, ON_WEB_WORKER, DEBUG } from "./api";
import {
  ClientMessageBroker,
  ClientMessageBroker_,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "./client_message_broker";
import { ServiceMessageBroker, ServiceMessageBroker_ } from "./service_message_broker";
import { PromiseSet } from "./promise_set";
import { ServiceMessageBrokerRegistry } from "./service_message_broker_registry";
import { REGISTER_SERVICE, REGISTER_CLIENT } from "./registry";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ServiceMessageBrokerRegistryReplica extends ServiceMessageBrokerRegistry {
  private _clientRegistryBroker: ClientMessageBroker = null;
  private isDebug;

  constructor(
    private _messageBus: MessageBus,
    private _serializer: Serializer,
    @Inject(DEBUG) isDebug,
  ) {
    super();
    this.isDebug = isDebug;
    this._messageBus.initChannel(REGISTRY_CHANNEL, true, true);
    this._clientRegistryBroker = new ClientMessageBroker_(
      this._messageBus,
      this._serializer,
      REGISTRY_CHANNEL,
      true,
    );
  }

  registerServiceMessageBroker(channel: string, port: MessagePort): void {
    let registryPromise = this._clientRegistryBroker.runOnService(
      new UiArguments(REGISTER_SERVICE, [
        new FnArg(channel, PRIMITIVE),
        new FnTransferableArg(port, PRIMITIVE),
      ]),
      null,
    );

    if (this.isDebug) {
      logger.out.info(
        `registerServiceMessageBroker ${self.location.hash} ${channel} registered : ${port}`,
      );
    }
  }

  registerClientMessageBroker(channel: string, port: MessagePort): void {
    this._clientRegistryBroker.runOnService(
      new UiArguments(REGISTER_CLIENT, [
        new FnArg(channel, PRIMITIVE),
        new FnTransferableArg(port, PRIMITIVE),
      ]),
      null,
    );
  }
}
